import { render } from "./FooterSave.vue?vue&type=template&id=eb60d748"
import script from "./FooterSave.vue?vue&type=script&lang=js"
export * from "./FooterSave.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__